// Эту хрень проще удалить чем типизировать
/* eslint-disable @typescript-eslint/no-explicit-any */
const flowFn = (queue: any, fn: any) => queue.then(fn);

/**
 * @function flowAsync
 * @param {...function} callbacks
 * @return {function}
 * @deprecated Такой хуйни у нас в проекте не позволю уберите
 */
export const flowAsync =
  (...callbacks: any) =>
  (input: any) =>
    callbacks.reduce(
      (queue: any, fn: any) => flowFn(queue, fn) as any,
      Promise.resolve(input),
    );
